// `invisible` rather than the `hidden` attribute: Tailwind's preflight forces
// `display:none !important` on `[hidden]`, which would kill the margin transition.
const CLOSED_CLASSES = [
  'invisible',
  'opacity-0',
  '-mt-5',
  'pointer-events-none',
];

const buttonOf = dropdown => dropdown.querySelector('.js-dropdown-button');

const panelOf = button =>
  document.getElementById(button.getAttribute('aria-controls'));

const setOpen = (button, open) => {
  const panel = panelOf(button);

  if (!panel) {
    return;
  }

  button.setAttribute('aria-expanded', String(open));

  for (const className of CLOSED_CLASSES) {
    panel.classList.toggle(className, !open);
  }
};

const holdsFocus = element => element.contains(document.activeElement);

const closeAll = except => {
  document
    .querySelectorAll('.js-dropdown-button[aria-expanded="true"]')
    .forEach(button => {
      if (button === except) {
        return;
      }

      const panel = panelOf(button);

      // Closing a panel that holds the focus would leave it on an invisible link.
      if (panel && holdsFocus(panel)) {
        button.focus();
      }

      setOpen(button, false);
    });
};

const focusEdgeLink = (button, edge) => {
  const links = panelOf(button)?.querySelectorAll('a[href]');

  if (!links?.length) {
    return;
  }

  links[edge === 'last' ? links.length - 1 : 0].focus();
};

if (window.dropdownInitialized === undefined) {
  window.dropdownInitialized = true;

  document.addEventListener('click', event => {
    const button = event.target.closest('.js-dropdown-button');

    if (!button) {
      if (!event.target.closest('.js-dropdown-child')) {
        closeAll();
      }

      return;
    }

    const open = button.getAttribute('aria-expanded') !== 'true';

    closeAll(button);
    setOpen(button, open);
  });

  document.addEventListener('keydown', event => {
    // The city comboboxes nested in the panels consume their own Escape: without this
    // the same keystroke would also close the menu and pull the focus out of the field.
    if (event.defaultPrevented) {
      return;
    }

    const dropdown = event.target.closest?.('.js-dropdown');

    if (!dropdown) {
      return;
    }

    const button = buttonOf(dropdown);

    if (event.key === 'Escape') {
      setOpen(button, false);
      button.focus();
      return;
    }

    if (event.target !== button) {
      return;
    }

    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      closeAll(button);
      setOpen(button, true);
      focusEdgeLink(button, event.key === 'ArrowUp' ? 'last' : 'first');
    }
  });

  document.addEventListener('focusout', event => {
    const dropdown = event.target.closest('.js-dropdown');

    if (dropdown && !dropdown.contains(event.relatedTarget)) {
      setOpen(buttonOf(dropdown), false);
    }
  });

  // Only a real mouse hovers: a tap fires these events just before its click, which
  // would open the panel and let the click toggle it straight back shut.
  const hoveredDropdown = event =>
    event.pointerType === 'mouse' ? event.target.closest('.js-dropdown') : null;

  const header = document.getElementById('header');

  header?.addEventListener('pointerover', event => {
    const dropdown = hoveredDropdown(event);

    if (!dropdown) {
      return;
    }

    const button = buttonOf(dropdown);

    if (button.getAttribute('aria-expanded') === 'true') {
      return;
    }

    closeAll(button);
    setOpen(button, true);
  });

  header?.addEventListener('pointerout', event => {
    const dropdown = hoveredDropdown(event);

    // Moving between the button and its own panel must not flicker the panel shut, and
    // a dropdown still holding the focus must stay operable.
    if (
      dropdown &&
      !dropdown.contains(event.relatedTarget) &&
      !holdsFocus(dropdown)
    ) {
      setOpen(buttonOf(dropdown), false);
    }
  });
}
